import { render, staticRenderFns } from "./Text11.vue?vue&type=template&id=0ed5744e&scoped=true"
import script from "./Text11.vue?vue&type=script&lang=ts"
export * from "./Text11.vue?vue&type=script&lang=ts"
import style0 from "./Text11.vue?vue&type=style&index=0&id=0ed5744e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed5744e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
